module.exports = __webpack_public_path__ + "img/dropdown-menu-product-5-1.5664cc02.png";